import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "article_active",
  "use": "article_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"article_active\"><path fill-rule=\"evenodd\" d=\"m7.185 9-.543 1H5.5l3-5.5 3 5.5h-1.145l-.542-1H7.185Zm.543-1L8.5 6.58 9.27 8H7.728ZM10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm2.333-8H14V9h-2v1h.333Zm0-2H14V7h-2v1h.333ZM6.5 14H14v-1H6v1h.5Zm0-2H14v-1H6v1h.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol